import { ROOT_VIEW } from "../renders/flexible-layout/utils";
export const sizesToGridTemplate = (items, itemsInfo, lastItemIndex) => items
    .map((item, index) => item.dragBar?.hidden !== true && index !== lastItemIndex
    ? `${itemsInfo.get(item.id).actualSize} ${item.dragBar?.size ?? 0}px` // Add a column to place the drag bar
    : itemsInfo.get(item.id).actualSize // Last item or not resizable
)
    .join(" ");
export const getFrSize = (item) => Number(item.size.replace("fr", "").trim());
export const getPxSize = (item) => Number(item.size.replace("px", "").trim());
export const hasAbsoluteValue = (item) => item.size.includes("px");
const getComponentSize = (item, fixedSizesSum) => {
    // Pixel value
    if (hasAbsoluteValue(item)) {
        return item.size;
    }
    // If the component has fr value, take into account the sum of fixed values
    // to calculate the actual relative value
    const frValue = getFrSize(item);
    if (fixedSizesSum === 0) {
        return `${frValue * 100}%`;
    }
    return item.fixedOffsetSize
        ? `calc(${frValue * 100}% - ${fixedSizesSum * frValue - item.fixedOffsetSize}px)`
        : `calc(${frValue * 100}% - ${fixedSizesSum * frValue}px)`;
};
export const updateSize = (itemUIModel, increment, fixedSizesSum, unitType) => {
    const itemInfo = itemUIModel.item;
    const currentValue = unitType === "px" ? getPxSize(itemInfo) : getFrSize(itemInfo);
    const newValue = currentValue + increment;
    itemInfo.size = `${newValue}${unitType}`;
    itemUIModel.actualSize = getComponentSize(itemInfo, fixedSizesSum);
};
export const updateOffsetSize = (itemUIModel, increment, fixedSizesSum) => {
    const itemInfo = itemUIModel.item;
    itemInfo.fixedOffsetSize ??= 0;
    itemInfo.fixedOffsetSize += increment;
    itemUIModel.actualSize = getComponentSize(itemInfo, fixedSizesSum);
};
export const fixAndUpdateLayoutModel = (layout, itemsInfo) => fixAndUpdateSubModel(layout.items, itemsInfo, ROOT_VIEW);
function fixAndUpdateSubModel(items, itemsInfo, parentItem) {
    let frSum = 0;
    let fixedSizesSum = 0;
    const lastItemIndex = items.length - 1;
    // Get the sum of all fr values. Also, store the sum of fixed sizes
    items.forEach((item, index) => {
        if (hasAbsoluteValue(item)) {
            fixedSizesSum += getPxSize(item);
        }
        else {
            frSum += getFrSize(item);
        }
        // Take into account previous resizes (fixedOffsetSize values) and add drag
        // bar sizes if this is not the last item
        fixedSizesSum +=
            (item.fixedOffsetSize ?? 0) +
                (index !== lastItemIndex ? item.dragBar?.size ?? 0 : 0);
    });
    // If there are fr values, we must adjust the frs values to be relative to 1fr
    if (frSum > 0) {
        items.forEach(item => {
            if (!hasAbsoluteValue(item)) {
                const frValue = getFrSize(item);
                const adjustedFrValue = frValue / frSum;
                item.size = `${adjustedFrValue}fr`;
            }
        });
    }
    // Update the actualSizes and fixedSizes maps
    items.forEach(item => {
        const itemUIModel = {
            item: item,
            parentItem: parentItem,
            actualSize: getComponentSize(item, fixedSizesSum)
        };
        if (item.items != null) {
            // eslint-disable-next-line prettier/prettier
            const group = item;
            const fixedSizesSum = fixAndUpdateSubModel(group.items, itemsInfo, group);
            itemUIModel.fixedSizesSum = fixedSizesSum;
        }
        itemsInfo.set(item.id, itemUIModel);
    });
    return fixedSizesSum;
}
export const updateComponentsAndDragBar = (info, itemsInfo, incrementInPx, gridTemplateDirectionCustomVar) => {
    // - - - - - - - - - Increments - - - - - - - - -
    // When the language is RTL, the increment is in the opposite direction
    const incrementInPxRTL = info.direction === "columns" && info.RTL ? -incrementInPx : incrementInPx;
    const layoutItems = info.layoutItems;
    const fixedSizes = info.fixedSizesSum;
    const remainingRelativeSizeInPixels = info.containerSize - info.fixedSizesSum;
    const incrementInFr = incrementInPxRTL / remainingRelativeSizeInPixels;
    // Components at each position of the drag bar
    const startItemUIModel = itemsInfo.get(info.itemStartId);
    const endItemUIModel = itemsInfo.get(info.itemEndId);
    // px / px
    if (hasAbsoluteValue(startItemUIModel.item) &&
        hasAbsoluteValue(endItemUIModel.item)) {
        updateSize(startItemUIModel, incrementInPxRTL, fixedSizes, "px");
        updateSize(endItemUIModel, -incrementInPxRTL, fixedSizes, "px");
    }
    // px / fr
    else if (hasAbsoluteValue(startItemUIModel.item)) {
        updateSize(startItemUIModel, incrementInPxRTL, fixedSizes, "px");
        updateOffsetSize(endItemUIModel, -incrementInPxRTL, fixedSizes);
    }
    // fr / px
    else if (hasAbsoluteValue(endItemUIModel.item)) {
        updateOffsetSize(startItemUIModel, incrementInPxRTL, fixedSizes);
        updateSize(endItemUIModel, -incrementInPxRTL, fixedSizes, "px");
    }
    // fr / fr
    else {
        updateSize(startItemUIModel, incrementInFr, fixedSizes, "fr");
        updateSize(endItemUIModel, -incrementInFr, fixedSizes, "fr");
    }
    // Update in the DOM the grid distribution
    info.container.style.setProperty(gridTemplateDirectionCustomVar, sizesToGridTemplate(layoutItems, itemsInfo, layoutItems.length - 1));
};
export const getMousePosition = (event, direction) => (direction === "columns" ? event.clientX : event.clientY);
//# sourceMappingURL=utils.js.map
